module.exports = __webpack_public_path__ + "img/HeroWithImageBackground.a4bd4412.png";